import styled, { css } from 'styled-components'
import { color } from 'ui/themes/utils'

import FocalImage from 'ui/blocks/FocalImage'

export const Line = styled.div`
  position: relative;

  padding: var(--minicart-padding);

  font-size: var(--minicart-font-size);

  border-bottom: 1px solid var(--minicart-border-color);

  z-index: 2;

  &:last-child {
    border-bottom: 0;
    /* Extra margin so you can always see the last item  */
    /* without overlapping with the services/powered by */
    margin-bottom: 90px;
  }
`

export const Remove = styled.a`
  cursor: pointer;
`

export const Image = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: var(--minicart-image-width);
  height: var(--minicart-image-width);

  & > ${FocalImage} {
    width: var(--minicart-image-width);
    height: var(--minicart-image-width);

    border-radius: var(--minicart-border-radius);
  }

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;

    width: var(--minicart-image-width);
    height: var(--minicart-image-width);

    background: var(--color-image-placeholder, #fbfdfc);
    border: 1px solid  var(--minicart-border-color);
    border-radius: var(--minicart-border-radius);
  }
`

export const Quantity = styled.div`
  display: flex;

  align-items: center;

  line-height: 1.4em;

  user-select: none;

  /* Quantity number */
  & > span {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 3.4em;
    height: 2.4em;

    border-top: 1px solid var(--minicart-border-color);
    border-bottom: 1px solid var(--minicart-border-color);
  }
`

export const QuantityButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2.4em;
  height: 2.4em;

  border: 1px solid var(--minicart-border-color);

  cursor: pointer;

  svg {
    opacity: 60%;
  }

  &:hover, &:active {
    svg {
      opacity: 100%;
    }
  }
`

export const ProductName = styled.div`
  font-weight: var(--minicart-font-weight-bold);
  line-height: 1.4em;

  ${({ large }) => large && css`
    font-size: calc(1em + 1px);
    margin-bottom: 1.2em;
  `}
`

export const Details = styled.div`
  display: flex;

  gap: 0.85em;

  & > div:not(${Image}) {
    width: 100%;
  }
`

export const StatusIndicator = styled.span`
  margin-top: 0.3em;

  font-size: 0.85em;
  line-height: 1.2em;

  color: var(--color-primary-foreground);

  &::before {
    display: inline-block;
    content: '';

    width: 0.7em;
    height: 0.7em;

    margin-right: 0.3em;

    border-radius: 100%;

    ${({ available }) => available ?
      css`
        background: ${color('Success/Base')};
      ` :
      css`
        background: ${color('Danger/Base')};
      `}
  }
`

export const Price = styled.div`
  display: flex;
  align-items: center;

  p {
    align-self: center;
    font-weight: var(--minicart-font-weight-bold);
  }

  svg {
    margin-right: 0.5em;
  }
`

export const DetailContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ center }) => center && css`
    align-items: center;
  `}

  &:last-child {
    margin-top: calc(var(--minicart-padding) / 2);
  }
`

export const BundleContents = styled.div`
  margin-top: var(--minicart-padding);
`

export const BundleContentsTitle = styled.div`
  cursor: pointer;

  & > span {
    margin-right: 0.5em;
  }
`

export const BundleContentsItem = styled.div`
  display: flex;
  align-items: center;

  gap: calc(var(--minicart-padding) / 2);
  margin-top: calc(var(--minicart-padding) / 2);

  ${Image} {
    width: calc(var(--minicart-image-width) / 2);
    height: calc(var(--minicart-image-width) / 2);

    ${FocalImage} {
      width: calc(var(--minicart-image-width) / 2);
      height: calc(var(--minicart-image-width) / 2);
      border-radius: calc(var(--minicart-border-radius) / 2);
    }

    span {
      width: calc(var(--minicart-image-width) / 2);
      height: calc(var(--minicart-image-width) / 2);
      border-radius: calc(var(--minicart-border-radius) / 2);
    }
  }
`

export const BundleContentsQuantity = styled.div`
  /* TODO: Get this color somewhere else */
  color: ${color('Text/Secondary')};
`

Line.Remove = Remove
Line.Quantity = Quantity
Line.QuantityButton = QuantityButton
Line.ProductName = ProductName
Line.Details = Details
Line.StatusIndicator = StatusIndicator
Line.Image = Image
Line.Price = Price
Line.DetailContainer = DetailContainer
Line.BundleContents = BundleContents
Line.BundleContentsTitle = BundleContentsTitle
Line.BundleContentsItem = BundleContentsItem
Line.BundleContentsQuantity = BundleContentsQuantity

export default Line
